import React from 'react';

import { TextInput } from 'react-admin';


const integerNumberParse = (v) => {
	if (v) {
		const match = String(v).match(/\d/gi);
		return Number(match && match.join(''));
	}
	return v;
};

// An identifier long enough to pass Number.MAX_SAFE_INTEGER, such as an 18-digit pallet
// number, is rounded by integerNumberParse. It keeps its digits by staying text.
const digitsParse = (v) => {
	if (v) {
		const match = String(v).match(/\d/g);
		return match ? match.join('') : '';
	}
	return v;
};

const floatNumberParse = (v, counter = '+') => {
	if (v) {
		const regRaw = `\\d+[,.]?\\d${counter}`;
		const reg = new RegExp(regRaw);

		const match = String(v).replace(/\s/g, '').match(reg);
		if (match == null) 
			return '';

		const parsedFloatString = match && match[0].replace(/,/g, '.');
		return parsedFloatString;
	}
	return v;
};



export const NumberInputEx = ({ type, digitsCount, format, parse, ...props }) => {
	const combinedParser = React.useCallback((v) => {
		let parsed;
		if (type === "float") {
			parsed = floatNumberParse(v, digitsCount ? `{0,${digitsCount}}` : '+');
		} else if (type === "digits") {
			parsed = digitsParse(v);
		} else {
			parsed = integerNumberParse(v);
		}
		return parse ? parse(parsed) : parsed;
	}, [type, digitsCount, parse]);

	return (
		<TextInput
			parse={combinedParser}
			format={format}
			{...props}
		/>
	);
}
